import React from "react"

import useLazyImport from "hooks/useLazyImport"
import SectionHeading from "components/section-heading"

const ImageGallery = ({ title, subtitle, images, elRef, dataId, hideOnPageLoad, ...props }) => {
  const styles = useLazyImport(() => import("./styles"))
  if (!styles) return null

  const { ImageGallerySection, Slider, Slide, Carousel, ImageSlide, ArrowLeft, ArrowRight } = styles
  return (
    <ImageGallerySection
      ref={elRef}
      hideOnPageLoad={hideOnPageLoad}
      data-exp-id={dataId}
      {...props}
    >
      <Carousel totalSlides={images.length} naturalSlideWidth={1} naturalSlideHeight={1}>
        <SectionHeading title={title} subtitle={subtitle} />
        <Slider>
          {images.map((component, idx) => (
            <ImageSlide key={component.key}>
              <Slide index={idx}>
                {component}
                <ArrowLeft />
                <ArrowRight />
              </Slide>
            </ImageSlide>
          ))}
        </Slider>
      </Carousel>
    </ImageGallerySection>
  )
}

export default ImageGallery
